import React, { lazy } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useAllCharges from "../../../hooks/AllCharge";
import { SETCARTDATA } from "../../../redux/features/CartData";
import DecrementItemData from "../../../utils/DecrementItemData";
import incrementItemData from "../../../utils/Increment";
import ItemSizeName, {
  ItemSizeVariationName,
} from "../../../utils/ItemSizeName";
import ParseFloat from "../../../utils/ParseFloat";
import VariationModal from "../../Modal/Variation-Modal";
import CustomizedModal from "../../Modal/Customized-Modal";
import { SETCARTOPENSTATUS } from "../../../redux/features/CartData";
import {
  getCookie,
  getSumOfAddOn,
  ReturnItemCorrectPrice,
} from "../../../utils/helper";
import Konsole from "../../../utils/konsole/Konsole";
import {
  getSumOfOptions,
  getSumOfSelectedCategory,
} from "../../../utils/helper";
import { CheckIsMeal } from "../../../utils/CustomizedCalculation/MealPrice";
import { CLEARCART } from "../../../redux/features/CartData";
import TooltipCom from "../../Tootlip/TooltipCom";
import { CLEARCHECKOUTADDRESS } from "../../../redux/features/CheckoutAddress";
import ThemeButton from "../../Buttons/ThemeButton";
import {
  ReturnPrice,
  ReturnPriceAndFree,
} from "../../../utils/orderUtils/OrderUtils";
import i18next from "i18next";
import { getItemNames } from "../../../utils/GetItemsName";
import useDeviceIos from "../../../hooks/useDeviceIos";
import useMobile from "../../../hooks/useMobile";
import { SETISSHOWMOBILESEARCH, SETISSHOWWEBSEARCH } from "../../../redux/features/common";
import useDiscountApply from "../../../hooks/useDiscountApply";
import useSelectedStore from "../../../hooks/useSelectedStore";
export default function CartItemDetail() {
  const { t } = useTranslation();
  const {setIsDiscountApply}=useDiscountApply()
  const [taxes, discount, service_charge, remaining_amount, totalPrice,totalPrice2,deliveryCharge2,card_fees2,round_off] = useAllCharges();
  const { items, itemCount, isCartOpen } = useSelector(
    (state: any) => state?.cartData
  );
  const {platformFee}=useSelectedStore()
  const { translations } = useSelector((state: any) => state?.languageData);
  const [lang, setLang] = useState(i18next.language);
  const [notes, setNotes] = useState({ text: "", id: "", uniqueId: "" });
  const {
    variationData,
    customizedData,
    cartData: { deliveryCharge, minOrderDeliveryPrice },
  }: any = useSelector((state: any) => state);
  // const [open, setOpen] = useState(false);
  const open = false;
  const disPatch = useDispatch();
  const iosDevice = useDeviceIos();
  const mobile = useMobile();

  const handleClear = () => {
    disPatch(CLEARCART());
    // @@ checkout address clear for minmum price
    disPatch(CLEARCHECKOUTADDRESS());
  };

  // @@ close cart
  const onCloseModal = () => {
    disPatch(SETISSHOWMOBILESEARCH(false));

    disPatch(SETISSHOWWEBSEARCH(false));
    disPatch(SETCARTOPENSTATUS(!isCartOpen));
  };
  // @@ handle note  features
  const [isNote, setIsNote] = useState(false);
  const notesOpen = (item: any) => {
    if (item.item_id == notes.id) {
      setNotes({
        ...notes,
        id: item.item_id,
        uniqueId: item.uniqueIndex,
      });
      setIsNote(!isNote);
    } else {
      setNotes({
        ...notes,
        text: item.notes || "",
        id: item.item_id,
        uniqueId: item.uniqueIndex,
      });
      setIsNote(true);
    }
  };
  // @@ add notes
  function addNotes() {
    const ui = items.find((e: any) => e.uniqueIndex === notes.uniqueId);
    const index = items.indexOf(ui);
    items.splice(index, 1, { ...ui, notes: notes.text });
    disPatch(SETCARTDATA(items));
    setIsNote(false);
    setNotes({ text: "", id: "", uniqueId: "" });
  }

  const returnOptionsMap = (item: any, type: any) => {
    return (
      <div className="itemSize ">
        {/* step option .... */}
        {item?.selectedoptions?.length > 0 && (
          <div className="text-base font-medium">
            {item?.selectedoptions?.map((step: any, index: any) => {
              return (
                <div key={index} className="flex justify-between">
                  <p className="text-[#8E8E8E] capitalize font-normal">
                   + {step?.title} <>{ReturnPriceAndFree(ReturnPrice(step))}</>
                  </p>
                </div>
              );
            })}
          </div>
        )}

        {/* category ... */}

        {item?.selectedCategory?.length > 0 && (
          <div className="text-base font-medium">
            {item?.selectedCategory?.map((step: any, index: any) => {
              return (
                <div key={index} className="flex justify-between">
                  <p
                    key={index}
                    className="text-[#8E8E8E] capitalize font-normal"
                  >
                   + {step?.mapNewItem?.name}{" "}
                    <>{ReturnPriceAndFree(ReturnPrice(step?.mapNewItem))}</>
                  </p>
                </div>
              );
            })}
          </div>
        )}

        {/* @@ add ons */}
        {item?.selected_addOn?.length > 0 &&
          item?.selected_addOn?.map((addOnItem: any, index: number) => {
            let price = addOnItem?.web_offered_price
              ? addOnItem?.web_offered_price
              : addOnItem?.offered_price
              ? addOnItem?.offered_price
              : 0;
            return (
              <div key={index} className="flex justify-between">
                <p className="text-[#8E8E8E] capitalize font-normal">
                 + {addOnItem?.addon_item?.name}{" "}
                  <>{ReturnPriceAndFree(addOnItem?.web_offered_price)}</>
                </p>
              </div>
            );
          })}
      </div>
    );
  };

  // @@ Return Meal Item
  const returnMealItem = (meal: any) => {
    return meal?.map((mealItem: any, mealIndex: number) => {
      let selectedMeal = mealItem?.selectedMealItem?.[0];
      if (selectedMeal) {
        let itemDetail = selectedMeal?.item_data?.[0];
        return (
          <>
            <p className="text-md text-[#1f1c1c] mt-1 ">
              {itemDetail?.name} {ItemSizeVariationName(selectedMeal)}{" "}
              {selectedMeal?.offered_price
                ? `(${ParseFloat(selectedMeal?.offered_price)})`
                : null}
            </p>
            {returnOptionsMap(selectedMeal, "meal")}
          </>
        );
      }
    });
  };

  return (
    <div className="relative h-screen prevent-select-disable new-item-checkout">
      <div className="cartData">
        <i
          className="fa fa-times text-xl font-normal cursor-pointer"
          onClick={() => onCloseModal()}
        ></i>
        <p className="text-2xl font-normal font-splekta mb-2">{t("mycart")}</p>
        <div
          //  className="variationWrapper itemDetail scroll-hidden"
          className={`variationWrapper itemDetail scroll-hidden ${
            mobile && iosDevice ? "variationWrapper-Height_ios" : ""
          }`}
        >
          {/* @@ display total itema and subtotal */}
          <div className="flex justify-between items-center text-lg font-normal border-b border-[#F0F0F0] mb-2">
            <p className="mb-2">
              {" "}
              {itemCount || 0} {itemCount > 1 ? "Items" : "Item"}{" "}
            </p>
            <div>
              <span className="text-[#757575]">{t("Checkout.subTotal")}: </span>
              <span className="font-bold">{ParseFloat(taxes?.sub_total)}</span>
            </div>
          </div>

          {/* Cart Items Display */}
          {items?.map((item: any, itemIndex: number) => {
            let item_Price = 0;

            if (CheckIsMeal(item?.is_meal)) {
              item_Price = item?.sub_total;
            } else {
              let selectedOptions = item?.selectedoptions || [];
              let selectedCategory = item?.selectedCategory || [];
              let selectedAddsOn = item?.selected_addOn || [];
              let sumOfAddOns = getSumOfAddOn(selectedAddsOn);
              let sumOfOptions = getSumOfOptions(selectedOptions);
              let sumOfCategory = getSumOfSelectedCategory(selectedCategory);
              item_Price =
                Number(item?.price) +
                Number(sumOfOptions || 0) +
                Number(sumOfCategory || 0) +
                Number(sumOfAddOns || 0);
            }
            item_Price = ReturnItemCorrectPrice(
              item_Price * (item?.quantity || 1),
              item?.tax_rate_list
            );
            return (
              <React.Fragment key={itemIndex}>
                <div className="repeatItem">
                  <div className="flex justify-between">
                    <div className="">
                      <div className="text-base font-medium mb-2">
                        <p className=" ">
                          {getItemNames(item?.name, translations, lang)}{" "}
                          {ItemSizeName(item)}
                        </p>
                        <p className="text-[#8E8E8E] font-normal">
                          {/* {ParseFloat(item_Price * (item?.quantity || 1))} */}
                          {ParseFloat(item_Price)}
                        </p>
                      </div>
                    </div>
                    {/* @@START Increment Decrement btns */}

                    {/* @@ delete button */}
                    <div className="flex gap-2">
                      <div
                        onClick={() =>
                          DecrementItemData(
                            item,
                            items,
                            disPatch,
                            itemCount,
                            item
                          )
                        }
                        className="h-8 w-8 border rounded-full flex justify-center items-center cursor-pointer"
                      >
                        {item.quantity > 1 ? (
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 38 5"
                            fill="currentColor"
                          >
                            <path d="M36.7188 0H0.78125C0.292969 0 0 0.390625 0 0.78125V3.90625C0 4.39453 0.292969 4.6875 0.78125 4.6875H36.7188C37.1094 4.6875 37.5 4.39453 37.5 3.90625V0.78125C37.5 0.390625 37.1094 0 36.7188 0Z"></path>
                          </svg>
                        ) : (
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 44 50"
                            fill="currentColor"
                          >
                            <path d="M28.9062 42.1875H30.4688C30.8594 42.1875 31.25 41.8945 31.25 41.4062V14.8438C31.25 14.4531 30.8594 14.0625 30.4688 14.0625H28.9062C28.418 14.0625 28.125 14.4531 28.125 14.8438V41.4062C28.125 41.8945 28.418 42.1875 28.9062 42.1875ZM13.2812 42.1875H14.8438C15.2344 42.1875 15.625 41.8945 15.625 41.4062V14.8438C15.625 14.4531 15.2344 14.0625 14.8438 14.0625H13.2812C12.793 14.0625 12.5 14.4531 12.5 14.8438V41.4062C12.5 41.8945 12.793 42.1875 13.2812 42.1875ZM42.9688 6.25H32.8125L29.4922 1.95312C28.7109 0.878906 27.0508 0 25.7812 0H17.9688C16.6016 0 14.9414 0.878906 14.1602 1.95312L10.9375 6.25H0.78125C0.292969 6.25 0 6.64062 0 7.03125V8.59375C0 9.08203 0.292969 9.375 0.78125 9.375H3.125V45.3125C3.125 47.9492 5.17578 50 7.8125 50H35.9375C38.4766 50 40.625 47.9492 40.625 45.3125V9.375H42.9688C43.3594 9.375 43.75 9.08203 43.75 8.59375V7.03125C43.75 6.64062 43.3594 6.25 42.9688 6.25ZM16.6992 3.80859C16.8945 3.41797 17.4805 3.22266 17.9688 3.125H25.7812C26.1719 3.22266 26.7578 3.41797 26.9531 3.80859L28.9062 6.25H14.8438L16.6992 3.80859ZM37.5 45.3125C37.5 46.1914 36.7188 46.875 35.9375 46.875H7.8125C6.93359 46.875 6.25 46.1914 6.25 45.3125V9.375H37.5V45.3125ZM21.0938 42.1875H22.6562C23.0469 42.1875 23.4375 41.8945 23.4375 41.4062V14.8438C23.4375 14.4531 23.0469 14.0625 22.6562 14.0625H21.0938C20.6055 14.0625 20.3125 14.4531 20.3125 14.8438V41.4062C20.3125 41.8945 20.6055 42.1875 21.0938 42.1875Z"></path>
                          </svg>
                        )}
                      </div>
                      <div className="h-8 w-8  flex justify-center items-center">
                        <p className="font-semibold textMd">{item.quantity}</p>
                      </div>
                      <div
                        onClick={() =>
                          incrementItemData(
                            item,
                            items,
                            disPatch,
                            itemCount,
                            item
                          )
                        }
                        className="h-8 w-8 border rounded-full flex justify-center items-center cursor-pointer"
                      >
                        <span className="">
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 38 38"
                            fill="currentColor"
                          >
                            <path d="M36.7188 16.4062H21.0938V0.78125C21.0938 0.390625 20.7031 0 20.3125 0H17.1875C16.6992 0 16.4062 0.390625 16.4062 0.78125V16.4062H0.78125C0.292969 16.4062 0 16.7969 0 17.1875V20.3125C0 20.8008 0.292969 21.0938 0.78125 21.0938H16.4062V36.7188C16.4062 37.207 16.6992 37.5 17.1875 37.5H20.3125C20.7031 37.5 21.0938 37.207 21.0938 36.7188V21.0938H36.7188C37.1094 21.0938 37.5 20.8008 37.5 20.3125V17.1875C37.5 16.7969 37.1094 16.4062 36.7188 16.4062Z"></path>
                          </svg>
                        </span>
                      </div>
                      <div className="iconBox" onClick={() => notesOpen(item)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 22 22"
                          fill="none"
                        >
                          <path
                            d="M4.96654 2.97668C3.98146 2.97668 3.18359 3.77455 3.18359 4.75963V17.2402C3.18359 18.2253 3.98146 19.0232 4.96654 19.0232H13.8813L19.2301 13.6744V4.75963C19.2301 3.77455 18.4322 2.97668 17.4472 2.97668H4.96654ZM4.96654 4.75963H17.4472V12.7829H12.9898V17.2402H4.96654V4.75963ZM6.74949 6.54258V8.32552H15.6642V6.54258H6.74949ZM6.74949 10.1085V11.8914H11.2068V10.1085H6.74949Z"
                            fill="#151E3F"
                          />
                        </svg>
                      </div>
                      {/* )} */}
                    </div>
                    {/* @@END Increment Decrement btns */}
                  </div>

                  {/* @@ Display Category and Item options  */}

                  {CheckIsMeal(item?.is_meal) && item?.meal?.length > 0
                    ? returnMealItem(item?.meal)
                    : returnOptionsMap(item, "customize")}

                  {/* @@ Display Category and Item options  */}

                  {item.notes ? (
                    <div className="mt-2 flex gap-1 textSm">
                      <span>{t("MyOrders.notes")}: </span>
                      {item.notes || ""}{" "}
                    </div>
                  ) : (
                    ""
                  )}
                  {isNote &&
                    notes.id == item.item_id &&
                    notes.uniqueId == item?.uniqueIndex && (
                      <div className="mt-2">
                        <textarea
                          onChange={(e) =>
                            setNotes({ ...notes, text: e.target.value })
                          }
                          rows={2}
                          maxLength={144}
                          className="border border-[#C5C5C5] textMd p-2 rounded-md w-full"
                          placeholder="Add Notes"
                          value={notes.text}
                        />
                        <div className="flex justify-end mb-2">
                          <button
                            onClick={addNotes}
                            className="bg-[#1466FA1A] rounded-md textSm textBlue px-3 py-1 font-semibold"
                          >
                            {t("MyAddress.save")}
                          </button>
                        </div>
                      </div>
                    )}
                  <hr />
                </div>
              </React.Fragment>
            );
          })}
          {/* <hr /> */}
          <div className="flexBox justifyBetween mt-3">
            <div className="textMd text-[#000] font-bold">
              {t("CartDetails.subTotals")}
            </div>
            <div className="textMd text-[#000] font-bold">
              {ParseFloat(taxes?.sub_total)}
            </div>
          </div>
          {/* @@START display tax information */}
          {taxes?.tax?.map((_: any, index: any) => {
            let text_name =
              _?.tax_name == "VAT" && _?.tax_type == "percentage"
                ? `${_?.tax_name}-${_?.tax_amount}% `
                : `${_?.tax_name}`;

            return (
              <div key={index} className="flexBox justifyBetween mt">
                <div className="textMd text-[#676767]">{text_name}</div>
                <div className="textMd text-[#000]">
                  {ParseFloat(_?.actual_tax_amount)}
                </div>
              </div>
            );
          })}
          {/* @@END display tax information */}
          {/* @@START discount section */}
          {discount ? (
            <div className="flexBox justifyBetween mt text-green-500">
              <div className="textMd  text-green-500">
                {t("MyOrders.discount")}
              </div>
              <div className="textMd  text-green-500">
                - {ParseFloat(discount)}
              </div>
            </div>
          ) : (
            ""
          )}
          {/* @@END discount section */}

          {/* @@ servie fees */}
          {service_charge ? (
            <div className="flexBox justifyBetween mt">
              <div className="textMd text-[#676767]">
                {t("Checkout.serviceFee")}
              </div>
              <div className="textMd text-[#000]">
                {ParseFloat(service_charge)}
              </div>
            </div>
          ) : (
            ""
          )}
          {/* @@ remaining amount */}
          {/* {remaining_amount ? (
            <div className="flexBox justifyBetween mt">
              <div className="textMd text-[#676767]">
                {t("MyOrders.remainingAmount")}
                {minOrderDeliveryPrice > 0 && (
                  <TooltipCom
                    text={`The store's minimum order fee is ${ParseFloat(
                      minOrderDeliveryPrice
                    )}.`}
                  >
                    <i className="fa fa-info-circle" />
                  </TooltipCom>
                )}
              </div>
              <div className="textMd text-[#000]">
                {ParseFloat(remaining_amount)}
              </div>
            </div>
          ) : (
            ""
          )} */}
          <hr className="mt-3" />
          {/* @@ total price */}
          {round_off != 0 && (
          <div className="flex justify-between ubermoveTextMedium">
            <p>{t("CartDetails.round_total")}</p>
            <p>{ParseFloat(round_off || 0)}</p>
          </div>
        )}
          <div className="flexBox justifyBetween mt-3">
            <div className="textMDREM text-[#000] ubermoveTextMedium">
              {t("CartDetails.total")}
            </div>
            <div className="textMDREM text-[#000] ubermoveTextMedium">
              {ParseFloat(totalPrice - deliveryCharge-(platformFee || 0))}
            </div>
          </div>
        </div>
      </div>

      <div className="rightFooter prevent-select-disable ">
        <div className="">
          {itemCount > 0 ? (
            <div
              className="w-full mb-5 flex justify-center items-center"
              onClick={() => {
                onCloseModal();
                if (!getCookie("yop-token")) {
                  sessionStorage.setItem("previous-page", "/checkout");
                }
              }}
            >
              <Link
                to="/checkout"
                // onClick={()=>window.location.replace('/checkout')}
                className="btn-secondary-cart  w-full block ubermoveTextMedium"
              >
                {t("Checkout.goToCheckout")}
              </Link>
            </div>
          ) : (
            ""
          )}

          <div
            className="w-full mb-5 flex justify-center items-center gap-2 checkout-btn-mobile"
            onClick={() => {
              onCloseModal();
            }}
          >
            <Link to="/menu" className="btn-border-cart-item">
              + {t("CartDetails.addMoreItems")}
            </Link>

            <div
              onClick={() => handleClear()}
              className="btn-border-cart-item cursor-pointer"
            >
              <i className="fa fa-trash me-1 pb-1" aria-hidden="true"></i>{" "}
              {t("clearCart")}
            </div>
          </div>
        </div>
      </div>
      {/* variation .... */}
      {open && variationData && Object.keys(variationData).length > 0 && (
        <VariationModal
          menu_id={variationData?.menu_id}
          taxdata={variationData}
          open={open}
          onCloseModal={onCloseModal}
        />
      )}
      {/* customized ..... */}
      {open && customizedData && Object.keys(customizedData).length > 0 && (
        <CustomizedModal
          menu_id={customizedData?.menu_id}
          taxdata={customizedData}
          open={open}
          onCloseModal={onCloseModal}
        />
      )}
    </div>
  );
}
